import React from 'react';
import './ContactSecondary.scss';

const ContactSecondary = (props) => (
  <div className="ContactSecondary contact-card contact-card--secondary col-sm-12 col-md-6" data-testid="ContactSecondary">
          {props.children}
  </div>
);

ContactSecondary.propTypes = {};

export default ContactSecondary;
